// Autogenerated file
export const documentStatusesEnum = {
    Unpaid: "Unpaid",
    Expired: "Expired",
    Paid: "Paid",
};
export const documentStatuses = [
    { label: "Не оплачен", value: "Unpaid" },
    { label: "Просрочен", value: "Expired" },
    { label: "Оплачен", value: "Paid" },
];
